import { useEffect, useRef } from 'react';
import { useUpdateNodeInternals } from 'reactflow';

// React Flow ya mide el nodo y sus handles al montarlo. Solo hay que avisarle
// cuando los handles cambian después (se guarda el nodo, aparecen botones...).
// Avisar también al montar duplicaba la medición de cada nodo al abrir un bot
// grande y retrasaba el dibujo de las conexiones.
const useSyncNodeInternals = (id, signature) => {
  const updateNodeInternals = useUpdateNodeInternals();
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    updateNodeInternals(id);
  }, [id, signature, updateNodeInternals]);
};

export default useSyncNodeInternals;
